export const PageCodes = Object.freeze({
  Disclaimer: 1,
  PrivacyPolicy: 2,
  Grievance: 3,
  TermsOfUse: 4,
});
